import Student from "./student";
import Teacher from "./teacher";

export default {
  namespaced: true,
  modules: {
    Teacher,
    Student
  }
}
